import { render, staticRenderFns } from "./ServicesSubSelector.vue?vue&type=template&id=37aea8dc&scoped=true&"
import script from "./ServicesSubSelector.vue?vue&type=script&lang=ts&"
export * from "./ServicesSubSelector.vue?vue&type=script&lang=ts&"
import style0 from "./ServicesSubSelector.vue?vue&type=style&index=0&id=37aea8dc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37aea8dc",
  null
  
)

export default component.exports